import { combineReducers } from "redux"
import CommonConfig from "./common-config/reducer"
import GameSubType from "./game-category/reducer"
import UserProfile from "./user-profile/reducer"
import UserBalance from "./user-balance/reducer"
import paginationData from "./pagination/reducer";

const rootReducer = combineReducers({
  CommonConfig,
  GameSubType,
  UserProfile,
  UserBalance,
  paginationData
})

export default rootReducer
